import React from 'react';
import '../styles/components/TablaBalance.css';

const TablaBalance = ({ data }) => {
  const formatNumber = (value) =>
    value !== null && value !== undefined
      ? Number(value).toLocaleString('es-CL')
      : '';

  if (!data || data.length === 0) {
    return <p>No hay datos para mostrar.</p>;
  }

  return (
    <div className="tabla-balance">
    <table>
      <thead>
        <tr>
          <th>Cuenta</th>
          <th>Debe</th>
          <th>Haber</th>
          <th>Deudor</th>
          <th>Acreedor</th>
          <th>Activo</th>
          <th>Pasivo</th>
          <th>Pérdida</th>
          <th>Ganancia</th>
        </tr>
      </thead>
      <tbody>
        {data.map((row) => (
          <tr key={row.id} className={row.cuenta?.toUpperCase() === 'TOTALES' ? 'fila-totales' : ''}>
            <td>{row.cuenta}</td>
            <td>{formatNumber(row.debe)}</td>
            <td>{formatNumber(row.haber)}</td>
            <td>{formatNumber(row.deudor)}</td>
            <td>{formatNumber(row.acreedor)}</td>
            <td>{formatNumber(row.activo)}</td>
            <td>{formatNumber(row.pasivo)}</td>
            <td>{formatNumber(row.perdida)}</td>
            <td>{formatNumber(row.ganancia)}</td>
          </tr>
        ))}
      </tbody>
    </table>
    </div>
  );
};

export default TablaBalance;
